var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"primary-nav elevation-3",style:(_vm.navStyles),attrs:{"id":"primary-nav","width":_vm.width,"fixed":"","dark":"","app":"","clipped":"","floating":"","mobile-break-point":"1024"},model:{value:(_vm.primaryNavVisible),callback:function ($$v) {_vm.primaryNavVisible=$$v},expression:"primaryNavVisible"}},[_c('accounts-list')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9066954e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/core/AppPrimaryNav.vue
// module id = null
// module chunks = 